
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/group-rv-bookings",
      function () {
        return require("private-next-pages/group-rv-bookings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/group-rv-bookings"])
      });
    }
  